<div class="flex flex-col p-8">
  <div class="absolute top-4 left-4 md:hidden" (click)="onBackClick.emit()">
    <mat-icon>arrow_back</mat-icon>
  </div>
  <h1 class="!font-bold capitalize !text-3xl !leading-tight !font-serif !mb-2">
    {{ isForLogin ? "Welcome back" : "Create a free account" }}
  </h1>
  <p *ngIf="!isForLogin">
    Get started with Prefund by creating your free account.
  </p>

  <div class="flex flex-col my-4">
    <button
      (click)="continueWithGoogle()"
      mat-flat-button
      class="p-2 vertical-center !rounded-full capitalize block !bg-[#de5246] !text-white font-sans mb-2 flex items-center"
    >
      <span class="inline-block bg-white rounded-full mr-2 p-[2px]">
        <span
          class="inline-block w-[20px] h-[15px] bg-[url('/assets/img/google-icon-logo.svg')] bg-contain bg-no-repeat bg-center align-middle text-center"
        ></span>
      </span>

      <span
        >{{ isForLogin ? "Continue with" : "Sign up with" }} with Google</span
      >
    </button>

    <!-- <button
      mat-flat-button
      class="p-2 vertical-center !rounded-full capitalize block !bg-[#4267B2] !text-white font-sans"
    >
      <mat-icon>apple</mat-icon>
      {{ isForLogin ? "Continue with" : "Signup with" }} with Facebook
    </button> -->
  </div>
  <span class="mb-2">
    {{ isForLogin ? "...or log in using" : "...or sign up" }} using an email and
    password:</span
  >
  <form class="flex flex-col mb-4" (submit)="loginOrSignUp(email, password)">
    <mat-form-field>
      <input
        matInput
        type="email"
        placeholder="Email"
        [(ngModel)]="email"
        name="email"
      />
    </mat-form-field>
    <mat-form-field>
      <input
        name="password"
        matInput
        type="password"
        placeholder="Password"
        [(ngModel)]="password"
      />
    </mat-form-field>
    <button
      [disabled]="isSubmitButtonLoading"
      mat-flat-button
      [ngClass]="{ '!bg-gray-700': isSubmitButtonLoading }"
      class="p-2 vertical-center !rounded-full capitalize block !bg-black !text-white font-sans"
    >
      <mat-icon>mail</mat-icon>
      {{
        isSubmitButtonLoading
          ? "One moment..."
          : isForLogin
          ? "Log in with email"
          : "Sign up with email"
      }}
    </button>
  </form>
  <p *ngIf="!isForLogin">
    By signing up you accept our
    <a href="{{ env.urls.terms }}" target="_blank">terms of service</a>
    and <a href="{{ env.urls.privacy }}">privacy policy</a>.
  </p>
  <p *ngIf="!isForLogin">
    Already have an account?
    <span class="underline cursor-pointer" (click)="onLoginClick.emit()"
      >Log in</span
    >
  </p>
  <p *ngIf="isForLogin">
    New to Prefund?
    <span class="underline cursor-pointer" (click)="onSignupClick.emit()"
      >Create a free account</span
    >
  </p>
</div>
